import { SxProps, Theme } from '@mui/material';
import { OpenSansFontWeights } from 'shared/custom/constants/commonConstants';

export const panelSX: Record<string, SxProps<Theme>> = {
	container: {
		width: '100%',
		maxWidth: 385,
		height: 'auto',
	},
};

export const panelMobileSX: Record<string, (theme: Theme) => SxProps<Theme>> = {
	container: (theme) => ({
		width: '100%',
		height: 'auto',
		alignSelf: 'center',
		borderRadius: '0',
		[theme.breakpoints.down('lg')]: {
			width: '100%',
			maxHeight: '80vh',
			borderTopLeftRadius: 8,
			borderTopRightRadius: 8,
			overflowY: 'auto',
		},
	}),
	closeIcon: () => ({
		cursor: 'pointer',
		color: 'grey.500',
		fontSize: '24px',
		'&:hover': {
			color: 'primary.main',
		},
	}),
	divider: () => ({
		borderColor: 'grey.50',
	}),
};

export const accountTitleSX: Record<string, SxProps<Theme>> = {
	container: {
		width: '100%',
		display: 'flex',
		flexDirection: 'row',
		paddingTop: '15px',
		paddingBottom: '15px',
		paddingLeft: '20px',
		paddingRight: '20px',
		gap: '5px',
		justifyContent: 'space-between',
		alignItems: 'center',
	},
	containerTitle: {
		display: 'flex',
		gap: '5px',
		alignItems: 'center',
	},
	title: {
		color: 'grey.500',
	},
};

export const loginRequestSX: Record<string, SxProps<Theme>> = {
	container: {
		width: '100%',
		py: '15px',
		px: '20px',
		gap: '15px',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'flex-start',
	},
	message: {
		color: 'grey.500',
		textAlign: 'justify',
	},
	buttonContainer: {
		width: '100%',
		display: 'flex',
		gap: '10px',
		flexDirection: 'row',
	},
	signInButton: {
		flex: 1,
	},
	registerButton: {
		flex: 1,
	},
};

export const proBoostSX: Record<string, SxProps<Theme>> = {
	container: {
		width: '100%',
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'flex-start',
		py: '15px',
		px: '20px',
		gap: '15px',
		backgroundColor: 'grey.50',
		cursor: 'pointer',
	},
	itemContainer: {
		width: '100%',
		height: 'auto',
		gap: '5px',
		textAlign: 'left',
		display: 'flex',
		flexDirection: 'column',
	},
	title: {
		color: 'grey.500',
		fontWeight: OpenSansFontWeights.semibold,
	},
	message: {
		color: 'grey.500',
	},
	link: {
		color: 'secondary.main',
	},
};

export const quickLinkDynamicSX: Record<string, (...args: any[]) => SxProps<Theme>> = {
	itemContainer: (theme: Theme): SxProps => ({
		width: '100%',
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		gap: '15px',
		cursor: 'pointer',
		':hover': {
			backgroundColor: 'grey.50',
		},
		borderBottom: `1px solid ${theme.palette.grey[50]}`,
	}),
};

export const quickLinkSX: Record<string, SxProps<Theme>> = {
	container: {
		flexDirection: 'column',
		alignItems: 'flex-start',
		height: 'auto',
		width: '100%',
	},
	itemContent: {
		width: '100%',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'flex-start',
		borderBottom: '1px solid grey.50',
	},
	itemIcon: {
		color: 'grey.500',
	},
	itemTitle: {
		color: 'grey.500',
		fontWeight: 600,
		textAlign: 'left',
	},
	itemDescription: {
		color: 'grey.500',
		fontWeight: 400,
		textAlign: 'left',
	},
	itemLink: {
		width: '100%',
		py: '15px',
		px: '20px',
		gap: '15px',
		display: 'flex',
		alignItems: 'center',
		textTransform: 'none',
		backgroundColor: 'none',
	},
};

export const extraLinkSX: Record<string, SxProps<Theme>> = {
	container: {
		flexDirection: 'column',
		alignItems: 'flex-start',
		height: 'auto',
		width: '100%',
		'&:hover': {
			cursor: 'pointer',
		},
	},
	itemContainer: {
		width: '100%',
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		padding: '10px 20px',
		'&:hover': {
			backgroundColor: 'grey.50',
		},
	},
	itemText: {
		color: 'secondary.main',
		fontWeight: OpenSansFontWeights.regular,
		marginLeft: '5px',
	},
	itemLink: {
		padding: 0,
		width: '100%',
	},
};
